import React from 'react';
import { Form, Input } from 'formik-antd';

const SalaryTransferLetter = (): React.ReactElement => {
  return (
    <>
      <h3>Salary Transfer Letter</h3>
      <Form.Item name={`entityName`} label="New Bank Name">
        <Input name="entityName" />
      </Form.Item>
      <Form.Item name={`notes`} label="Additional Notes">
        <Input.TextArea name="notes" />
      </Form.Item>
    </>
  );
};

export default SalaryTransferLetter;
